import React from 'react';
import "../../App.css" ;
import "./errorPage.css" ;


function ErrorPage() {
  return <div className='pagesContainer '>
    <h1 className="no-match">Page Not Found!</h1>
  </div>;
}

export default ErrorPage;